import useTranslation from "next-translate/useTranslation";
import React, { VFC } from "react";
import { colorBlack } from "lib/constants";
import FormAttentionWrap from "./FormAttentionWrap";

interface Props {
  presence: "yes" | "no";
}

const FormAttentionPresence: VFC<Props> = ({ presence }) => {
  const { t } = useTranslation();
  return (
    <FormAttentionWrap color={presence === "yes" ? colorBlack[600] : undefined}>
      {presence === "yes" ? (
        <>{t("common:attention.required", {}, { fallback: "必須" })}</>
      ) : (
        <>{t("common:attention.optional", {}, { fallback: "任意" })}</>
      )}
    </FormAttentionWrap>
  );
};

export default FormAttentionPresence;
